var local = location.host.indexOf('localhost') !== -1
